<template>
  <div id="app">
    <!-- <router-view /> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
import '@/utils/snowGround'
import Cookies from 'js-cookie'
import { debug } from '@/utils/debug'
import { noticePatient2Pharmacist } from '@/utils/trtc'
import { cancelInquiry } from '@/api/video'
import { getCookie } from '@/utils/auth'
import { sendLog } from '@/api/index'
import { initLog, parseTime } from '@/utils/'
import { Dialog  } from 'vant'
export default {
  name: 'App',
  data() {
    return {
      organSign: getCookie('native_organSign'),
      doctorGuid: '',
      isInit: true, // 是否初始化
      ErrorFlag: false // 是不是异常断开
    }
  },
  computed: {
    logs() {
      return this.$store.state.app.log
    },
    roomNumber() {
      // 房间号码
      return this.$store.getters.roomNumber
    },
    inquiryRecordGuid() {
      // 问诊记录guid
      return this.$store.getters.inquiryRecordGuid
    },
    socketStatus() {
      return this.$store.getters.socketStatus
    }
  },
  watch: {
    $route(to) {
      if (this.ErrorFlag) {
        this.websocketError()
        this.ErrorFlag = false
      }
      // 初始化页面，并且是个人中心首页
      if (this.isInit && to.name === 'prescriptionmanage') {
        this.isInit = false // 保证方法只执行一次
        return
      }
    },
    logs(list) {
      if (list.length >= 50) {
        this.onSendLog(list)
      }
    }
  },
  created() {
    const client = getCookie('native_client') || ''
    if (client == 'android' || client == 'ios' || client == 'pad') {
      this.organSign = getCookie('native_organSign')
    } else {
      this.organSign = getCookie('organSign')
    }
    // 物理返回处理
    window.clickNativeBack = () => {
      const name = this.$route.name

      // action[name]();
      // 派单统计页
      if (name === 'prescription') {
        this.cancelConfirm()
        return false
      }
      // 填写信息页 || 新加图文问诊页面返回
      if (name === 'interrogationInfo' || name === 'interrogationInfoText') {
        this.$router.replace('/home');
        return false;
      }
      // 处方详情页返回
      if (name === 'waitpre') {
        // 如果是，列表页，返回历史记录上一页
        if (this.$route.query['type'] === 'record') {
          history.go(-1)
          return false
        } else {
          this.$router.replace('/home')
          return false
        }
      }
      // 点无需开方页
      if (name === 'preclose') {
        // 如果是，列表页，返回历史记录上一页
        if (this.$route.query['type'] === 'record') {
          history.go(-1)
          return false
        } else {
          this.$router.replace('/home')
          return false
        }
      }
      // 我的页，点返回，或者 首页
      if (name === 'mine' || name === 'home') {
        return false
      }
      history.go(-1)
    }
    // 正常问诊，点击关闭，取消问诊
    // handleVideo(0) 未接通，患者取消问诊
    // handleVideo(1) 通话中关闭（问诊取消）
    // handleVideo(2) 患者进入房间
    // handleVideo(3) 医生离开房间
    // handleVideo(4) 接通中患者离开
    window.handleVideo = data => {
      // console.log('roonumber', this.roomNumber, 'roonuinquiryRecordGuidmber', this.inquiryRecordGuid, 'patientGuid', this.patientGuid)
      // console.log('data' + data, typeof data)
      const num = Number(data)
      console.log('handleVideo num:', num, 'typeof num:', typeof num)
      if (num === 0) {
        console.log('handleVideo--调取消接口')
        console.log('handleVideo--0000000000000000')
        this.onCancelInquiry(() => {
        if (
          this.$route.name !== 'interrogationInfoText' &&
          this.$router.name !== 'waitpre'
        ) {
          this.$router.push('/interrogationInfoText')
        }
        })
      } else if (num === 1) {
        console.log('handleVideo--this.$route.name', this.$route.name)
        console.log('handleVideo')
        console.log('handleVideo--1111111111111111', this.$route.name)
        this.$route.name !== 'waitpre' &&
          this.$router.push({ 
            name: 'waitpre', 
            back: 'info', 
            params:{
              evaluate: true
            }  
          })
      }else if (num === 2) {
        console.log('handleVideo--22222222222222', this.$route.name)
        window.joinRoomCountDownFn();
      }else if (num === 3) {
        console.log('handleVideo--33333333333333', this.$route.name)
        window.streamRemoved()
      }else if (num === 4) {
        console.log('handleVideo--44444444444444', this.$route.name)
        window.localityRemoved()
      }
    }
    // 再次联系医生 ，点击关闭视频，取消问诊
    window.handleUserVideo = data => {
      const num = Number(data)
      console.log('handleUserVideo num:', num, 'typeof num:', typeof num)
      if (num === 0) {
        console.log('handleUserVideo--调取消接口')
        this.onCancelInquiry()
      } else if (num === 1) {
        console.log('handleVideo--this.$route.name', this.$route.name)
        console.log('handleUserVideo')
        this.$route.name !== 'waitpre' && this.$router.push('/waitpre')
      }
    }
    console.log('this.socketStatus', this.socketStatus)
    !this.socketStatus && this.websocketConnect()
  },
  mounted() {

    const date = parseTime(new Date())
    const organSign = Cookies.get('native_organSign')
    const pageId =
      organSign + '_' + Math.ceil(Math.random() * 100000) + '_' + date
    Cookies.set('pageId', pageId)
    this.$store.dispatch(
      'setLog',
      initLog({
        message: 'APP 加载成功',
        type: '/app'
      })
    )
    setInterval(() => {
      if (this.logs.length) {
        this.onSendLog(this.logs)
      }
    }, 20000)
    debug(this.$el)
  },
  methods: {

    /**
     * @description: 加log日志
     * @param {Object} json对象
     * @return:
     */
     setLog(msg) {
       $hyjkLoggerSdk.info(initLog(msg), "PATIENTH5");
    },
    /**
    * @description: 取消问诊，二次弹窗询问
    */
    cancelConfirm() {
      Dialog.confirm({
        title: '提示',
        message: '系统正在为您派单，确定要退出吗？'
      })
        .then(() => {
          this.cancel();
        })
        .catch(() => {
          console.log('no')
        })
    },
    cancel() {
      const info = JSON.parse(localStorage.getItem('params'))
      this.isShowLoading = true
      console.log(`点击取消问诊,roomNumber:${this.roomNumber}`)
      this.setLog({
        message: `点击取消问诊,roomNumber:${this.roomNumber}`,
        type: '/APP'
      })
      cancelInquiry({
        roomNumber: info.roomNumber,
        inquiryRecordGuid: this.$store.getters.inquiryRecordGuid,
        patientGuid: info.patientGuid
      })
        .then(res => {
          this.isShowLoading = false
          console.log(`取消问诊接口成功1,roomNumber:${this.roomNumber}`)
          this.setLog({
            message: `取消问诊接口成功,roomNumber:${this.roomNumber}`,
            type: '/APP'
          })
          history.go(-1)
        })
        .catch(err => {
          this.isShowLoading = false
          this.setLog({
            message: '取消问诊接口失败',
            type: '/APP'
          })
          history.go(-1)
          console.error('视频取消接口调用失败', err)
        })
    },
    websocketConnect() {
      this.$store.dispatch('setSocketStatus', true)
      noticePatient2Pharmacist({
        url: 'patient/' + this.organSign,
        onmessage: e => {
          console.log('e.data:', e.data)
          const data =
            e.data && e.data.indexOf('{') !== -1 ? JSON.parse(e.data) : ''
          if (data.type === 'physician-to-patient') {
            console.log('data.body', data.body)
            try {
              const { doctorGuid, patientGuid, message } = data.body
              console.log(
                'patientGuid===this.$store.getters.patientGuid',
                patientGuid,
                this.$store.getters.patientGuid
              )
              this.doctorGuid = doctorGuid
            } catch (e) {
              console.error('患者端接收有错误：', e)
            }
          }
          // SF新增监听消息条数
          console.log('data_type', data.type)
          const str = data.body ? data.body.info : ''
          console.log('data_info', str)
          if (
            data.type === 'patient-message'
          ) {
            console.log('data_body', data.body, typeof data.body)
            const prescriptionGuid = data.body.prescriptionGuid
            try {
              this.$store.dispatch('getnews', 'add')
              console.log('websocket prescriptionGuid', prescriptionGuid)
              // 因为prescriptionGuid不会变化，所以我用一个随机数触发watch
              this.$store.commit('setRandom', Math.random())
              this.$store.dispatch('getNewsGuid', prescriptionGuid)
            } catch (error) {
              console.error(error)
            }
          }
          // const redata = JSON.parse(e)
          console.log('数据接收成功', e)
        },
        onopen: e => {
          console.log('onopen', e)
        },
        onerror: e => {
          console.log('onerror', e)
          this.ErrorFlag = true
          console.log('异常断开连接', e)
        },
        onclose: e => {
          console.error('onclose,socket连接关闭！', e)
          this.ErrorFlag = true
        }
      })
    },
    websocketError() {
      return this.$store.dispatch('setSocketStatus', false)
      this.websocketConnect()
    },
    onCancelInquiry(callback) {
      console.log('取消的房间号', this.roomNumber)
      let i = 0
      let time = 1000
      const that = this
      fn()
      function fn() {
        cancelInquiry({
          roomNumber: that.roomNumber,
          inquiryRecordGuid: that.inquiryRecordGuid,
          patientGuid: that.$store.getters.patientGuid
        })
          .then(res => {
            console.error('视频取消接口调用成功', res)
            typeof callback === 'function' && callback()
          })
          .catch(err => {
            console.error('视频取消接口调用失败', err)
            if (i > 3) {
              that.$toast({
                message: '视频取消失败'
              })
              return
            }
            setTimeout(() => {
              i++
              time *= i
              console.log(`视频取消接口第${i}次`)
              fn()
            }, time)
          })
      }
    },
    /**
     * @description: 上传性能日志
     * @param {type}
     * @return:
     */
    async onSendLog(params) {
      try {
        await sendLog(params)
        // 清除之前打印日志
        this.$store.dispatch('resetLog')
      } catch (err) {
        console.log('性能日志异常', err)
      }
    }
  }
}
</script>
<style lang="scss">
@import './fonts/fonts/font.css';
body {
  margin: 0;
  padding: 0;
}
#app {
  /* position: relative; /*定位*/
  min-height: 100vh;
}
#app .van-nav-bar__left .van-icon.van-icon-arrow-left{
  font-size: 24px;
  color: #666;
}
.van-field__control:disabled {
  color: #333 !important;
}

</style>
